import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PageComponent } from './page/page.component';
import { RoughcheckComponent } from './roughcheck/roughcheck.component';
import { RoughcheckFormComponent } from './roughcheck-form/roughcheck-form.component';
import { AssessmentComponent } from './assessment/assessment.component';
import { SectionsComponent } from './sections/sections.component';
import { SectionComponent } from './section/section.component';
import { QuestionHelpComponent } from './question-help/question-help.component';
import { QuestionFeedbackComponent } from './question-feedback/question-feedback.component';
import { QuestionNotesComponent } from './question-notes/question-notes.component';
import { ReportComponent } from './report/report.component';
import { ReportsComponent } from './reports/reports.component';
import { ActionsComponent } from './actions/actions.component';
import { HelpComponent } from './help/help.component';
import { RoughcheckGuard } from './roughcheck/roughcheck.guard';
import { AssessmentGuard } from './assessment/assessment.guard';

// Guard not working so disable
//    canActivate: [RoughcheckGuard]
const routes: Routes = [
  { path: 'a/:rref/assessment', component: AssessmentComponent, pathMatch: 'full' },
  { path: 'a/:rref/help', component: HelpComponent, pathMatch: 'full' },
  { path: 'a/:rref/:aref/assessment', component: AssessmentComponent, pathMatch: 'full' },
  { path: 'a/:rref/:aref/sections', component: SectionsComponent, pathMatch: 'full' },
  { path: 'a/:rref/:aref/section/:id', component: SectionComponent, pathMatch: 'full' },
  { path: 'a/:rref/:aref/section/:id/:id/notes', component: QuestionNotesComponent, pathMatch: 'full' },
  { path: 'a/:rref/:aref/section/:id/:id/feedback', component: QuestionFeedbackComponent, pathMatch: 'full' },
  { path: 'a/:rref/:aref', component: RoughcheckComponent, pathMatch: 'full' },
  { path: 'a/:rref', component: RoughcheckComponent, pathMatch: 'full' },
  { path: 'a/:rref/:aref/report', component: ReportsComponent, pathMatch: 'full'},
  { path: 'a/:rref/:aref/action', component: ActionsComponent, pathMatch: 'full'},
  { path: 'a/:rref/:aref/help', component: HelpComponent, pathMatch: 'full' },
  { path: 'home', component: HomeComponent, pathMatch: 'full' },
  { path: 'start', component: RoughcheckFormComponent, pathMatch: 'full' },
  { path: 'help', component: HelpComponent, pathMatch: 'full' },
  { path: 'help', component: PageComponent, outlet: 'popup'},
  { path: 'questionhelp', component: QuestionHelpComponent, outlet: 'popup'},
  { path: '',   redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
